import * as Yup from "yup";

export const validationSchema = Yup.object({
  name: Yup.string().required("שם המוצר הוא שדה חובה"),

  price: Yup.number()
    .typeError("מחיר חייב להיות מספר")
    .required("מחיר הוא שדה חובה")
    .positive("המחיר חייב להיות מספר חיובי"),

  description: Yup.string().nullable(true).optional(),

  categoryIds: Yup.array()
    .of(Yup.number())
    .min(1, "יש להוסיף לפחות קטגוריה אחת למוצר"),

  parentCategoryId: Yup.number().min(0),
  categoryId: Yup.number().min(0),
  subCategoryId: Yup.number().min(0),

  image: Yup.mixed().when("id", {
    is: (v) => v === 0,
    then: (schema) => schema.required("יש להעלות תמונה"),
    otherwise: (schema) => schema.nullable().optional(),
  }),
});